import React from 'react';
import ArcaChip from './ArcaChip';

const STATUS_COPY = {
  valid: 'ARCA confirmó que el comprobante coincide con los registros oficiales.',
  observed: 'ARCA encontró el comprobante pero hay diferencias con los datos extraídos.',
  rejected: 'ARCA no pudo constatar el comprobante con los datos informados.',
  error: 'No se pudo completar la consulta contra ARCA.',
};

export default function ArcaDetailsModal({
  open,
  onClose,
  arca,
  audit,
  loading = false,
}) {
  if (!open) return null;

  const status = arca?.state || arca?.status || 'sin_constatar';
  const comparison = arca?.comparison || audit?.comparison || [];
  const observations = arca?.observaciones || arca?.observations || [];
  const errors = arca?.errors || [];
  const matched = comparison.filter((row) => row.match).length;
  const total = comparison.length;

  return (
    <div className="dv-arca-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="dv-arca-modal"
        role="dialog"
        aria-labelledby="arca-details-title"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="dv-arca-modal-head">
          <div>
            <h2 id="arca-details-title">Detalle de validación ARCA</h2>
            <p className="dv-arca-modal-sub">
              Comparación entre los datos extraídos del PDF y los registrados en ARCA.
            </p>
          </div>
          <button type="button" className="dv-close" onClick={onClose} aria-label="Cerrar">
            ✕
          </button>
        </header>

        <div className="dv-arca-modal-status">
          <ArcaChip arca={arca} loading={loading} />
          {STATUS_COPY[status] && <p>{STATUS_COPY[status]}</p>}
          {arca?.checked_at && (
            <p className="dv-arca-modal-meta">
              Constatado {new Date(arca.checked_at).toLocaleString('es-AR')}
              {arca.environment ? ` · ${arca.environment}` : ''}
              {total > 0 ? ` · ${matched}/${total} campos coinciden` : ''}
            </p>
          )}
        </div>

        {loading ? (
          <div className="dv-arca-modal-loading">Cargando detalle…</div>
        ) : (
          <>
            {comparison.length > 0 ? (
              <div className="dv-arca-compare-wrap">
                <table className="dv-arca-compare">
                  <thead>
                    <tr>
                      <th>Campo</th>
                      <th>Extraído</th>
                      <th>ARCA</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comparison.map((row) => (
                      <tr
                        key={row.key}
                        className={row.match ? 'dv-arca-compare-row--ok' : 'dv-arca-compare-row--diff'}
                      >
                        <td>{row.label}</td>
                        <td className="mono">{row.extracted_value || '—'}</td>
                        <td className="mono">{row.arca_value || '—'}</td>
                        <td>
                          <span className={`dv-arca-compare-pill dv-arca-compare-pill--${row.match ? 'ok' : 'diff'}`}>
                            {row.match ? 'Coincide' : 'Difiere'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="dv-arca-modal-empty">
                No hay comparación disponible para este intento. Reintentá la constatación para generar el detalle.
              </div>
            )}

            {observations.length > 0 && (
              <div className="dv-arca-modal-notes">
                <h3>Observaciones ARCA</h3>
                <ul>
                  {observations.map((msg, index) => (
                    <li key={`obs-${index}`}>{msg}</li>
                  ))}
                </ul>
              </div>
            )}

            {errors.length > 0 && (
              <div className="dv-arca-modal-notes dv-arca-modal-notes--error">
                <h3>Errores</h3>
                <ul>
                  {errors.map((msg, index) => (
                    <li key={`err-${index}`}>{msg}</li>
                  ))}
                </ul>
              </div>
            )}

            {audit && (
              <footer className="dv-arca-modal-foot">
                <span>Intento {audit.attempt_id?.slice(0, 8) || '—'}</span>
                <span>{audit.trigger || 'manual'}</span>
                {audit.duration_ms != null && <span>{audit.duration_ms} ms</span>}
              </footer>
            )}
          </>
        )}
      </div>
    </div>
  );
}
